import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import Select from 'react-select'
class AddPickUp extends React.Component {
  state = {
    pickup_desc: '',
    pickup_lat: '',
    pickup_long: '',
    pickup_map: '',
    pickup_address_en: '',
    pickup_address_ar: '',
    pickup_other_detail: '',
    isData: false,
    port_fee: null,
    port_fee_type: '',
    pick_id: null,
    port_fee_type_list: [
      {
        id: 'percentage',
        name: 'Percentage',
      },
      {
        id: 'amount',
        name: 'Amount',
      },
    ],
  }
  componentDidMount() {
    this.dashbord()
    this.getPicKup()
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleAddressChange = (event) => {
    this.setState({ pick_id: event })
  }

  handleAddressClear = () => {
    this.setState({ pick_id: null })
  }
  dashbord = async () => {
    this.setState({ isloading: true })
    var cruiseId = this.props.boatId

    await axios
      .get(Constant.getAPI() + `/cruise/get-pick-up/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          if (this.props.pickupId) {
            const matchItem = res.data.data
            if (matchItem !== undefined) {
              const itm = matchItem
              this.setState({
                ...itm,
                pick_id: itm.pick_id ? {
                  value: itm.pick_id,
                  label: `${itm.pickup_address_en}/${itm.pickup_address_ar}`
                } : null,
              })
            }
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  getPicKup = async () => {
    this.setState({ isloading: true })

    await axios
      .get(Constant.getAPI() + `/admin/pick-up-listing`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ getPickups: res.data.data })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addPickUp = () => {
    var that = this
    var data = new FormData()
    that.setState({ isSaving: true })
    // if (that.state.cruise_cat_en === undefined ||
    //     that.state.cruise_cat_en === null ||
    //     that.state.cruise_cat_en === "" || that.state.cruise_cat_ar === undefined ||
    //     that.state.cruise_cat_ar === null ||
    //     that.state.cruise_cat_ar === "") {
    //     document.getElementById("")?.focus();
    //     that.setState({ isSaving: false });
    //     return false;
    // }
    var cruiseId = this.props.boatId
    var pickUp_address_id = this.state.getPickups?.filter((item) => item.id === this.state.pick_id?.value)
    data = {
      pickup_desc: that.state.pickup_desc,
      cruise_id: cruiseId,
      pickup_lat: pickUp_address_id?.[0]?.pickup_lat,
      pickup_long: pickUp_address_id?.[0]?.pickup_long,
      pick_id: pickUp_address_id?.[0]?.id,
      pickup_map: that.state.pickup_map,
      pickup_address_en: pickUp_address_id?.[0]?.pickup_address_en,
      pickup_address_ar: pickUp_address_id?.[0]?.pickup_address_ar,
      pickup_other_detail: that.state.pickup_other_detail,
      port_fee: that.state.port_fee,
      port_fee_type: that.state.port_fee_type,
    }

    if (this.props.pickupId) {
      this.setState({ isData: true })
      axios
        .put(Constant.getAPI() + '/cruise/update-pick-up', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status) {
            this.setState({ isData: false })
            Swal.fire({
              title: 'PickUp Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/boatsmaster/${this.props.boatType}/${this.props.boatId}/pickup-lists`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      this.setState({ isData: true })
      axios
        .post(Constant.getAPI() + '/cruise/add-pick-up', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'PickUp Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/boatsmaster/${this.props.boatType}/${this.props.boatId}/pickup-lists`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }
  onSaveData = () => {
    var that = this
    that.setState({ isSaving: true })

    that.addPickUp()
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Address</label>
                <div className="col-sm-9">
                  <Select
                    name="pick_id"
                    value={this.state.pick_id}
                    onChange={this.handleAddressChange}
                    options={this.state.getPickups?.map((item) => ({ value: item.id, label: `${item.pickup_address_en}/${item.pickup_address_ar}` }))}
                    isMulti={false}
                    isSearchable={true}
                    isClearable
                    onClear={this.handleAddressClear}
                    placeholder="Select Address"
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description</label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="pickup_desc"
                    placeholder="Description"
                    onChange={this.handleChange}
                    value={this.state.pickup_desc}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Port Fee Type 2</label>
                <div className="col-sm-9">
                  <select
                    name="port_fee_type"
                    className="form-control"
                    value={this.state.port_fee_type}
                    onChange={this.handleChange}
                  >
                    <option>Select Type</option>
                    {this.state.port_fee_type_list.map((item) => (
                      <option
                        value={item.id}
                        key={item.name}
                      >
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Port Fee Amount</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="port_fee"
                    id="port_fee"
                    placeholder="Port Fee Amount"
                    value={this.state.port_fee}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Map</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="pickup_map"
                    placeholder="Map"
                    onChange={this.handleChange}
                    value={this.state.pickup_map}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Other Details</label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="pickup_other_detail"
                    placeholder="Other Details"
                    onChange={this.handleChange}
                    value={this.state.pickup_other_detail}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                <Link
                  to={`/boatsmaster/${this.props.boatType}/${this.props.boatId}/pickup-lists`}
                  className="btn btn-outline-secondary m-2 "
                >
                  <i className="icofont icofont-rounded-double-left"></i>
                  Back
                </Link>
                {this.state.isData ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AddPickUp
